import styled, { css } from 'styled-components';
import { Box, Text } from '@bechtel/gds';

export const DashboardProgressRowStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  position: relative;
  padding-top: ${({ theme }) => theme.spacings[400]};
  padding-bottom: ${({ theme }) => theme.spacings[400]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
`;

export const ProgressContainerStyled = styled(Box).attrs({
  mx: { sm: '600' },
  px: { sm: '600' },
  pt: { sm: '200' },
  alignItems: { sm: 'center' },
  flexGrow: { sm: 1 },
})`
  height: 82px; /** TODO Remove child should determine its height */
  ${({ theme }) => css`
    background-image: linear-gradient(274deg, ${theme.colors.bechtel.blue[1000]}, ${theme.colors.bechtel.blue[800]});
    border-radius: ${theme.radii[200]};
    position: relative;
  `}
`;

export const CalulationParametersStyled = styled(Text).attrs({
  weight: '600',
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[200]};
    text-align: center;
    margin: 0 ${theme.spacings[400]};
    padding-top: ${theme.spacings[100]};
    padding-bottom: ${theme.spacings[100]};
    padding-left: ${theme.spacings[200]};
    padding-right: ${theme.spacings[200]};
  `}
`;

export const TargetCalculationStyled = styled(Box).attrs({ px: { sm: '400' }, py: { sm: '400' } })`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.colors.grey[200]};
    font-size: ${theme.fontSizes[300]};
  `}
`;
